











































import { Component, Prop, Mixins } from 'vue-property-decorator';
import { Mutations, Views, ViewModes } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import CalendarEventData from '@/ts/CalendarEventData';
import moment from 'moment';

@Component
export default class SingleCalendarEvent extends Mixins(DateMethods) {
    @Prop() public item!: CalendarEventData;

    constructor() {
        super();
    }

    get eventClass(): object {
        return {
            'hococo-calendar-event-header-background__important': this.item.isImportant,
            'hococo-calendar-event-header-background__unclassified': !this.item.isImportant,
        };
    }

    get dataLoaded(): boolean {
        return (typeof this.item !== 'undefined');
    }

    public goBack() {
        this.$store.commit(Mutations.UPDATE_ACTIVE_EVENT, null);
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Events,
            viewMode: ViewModes.Events.All,
        });
    }

}
